import * as yup from 'yup'

import {
  UPLOAD_MAX_FILES_LIMIT,
  UPLOAD_MIN_MULTIPLE_FILES
} from 'utils/customFieldUpload'

export const extraFieldsSchema = yup.object({
  field_type: yup.string().required('Tipo do campo é obrigatório.'),
  type: yup.string().when('field_type', {
    is: 'accept',
    then: yup.string().required('Tipo da opção é obrigatório.'),
    otherwise: yup.string()
  }),
  title: yup.string().required('Título do campo é obrigatório.'),
  accept_text: yup.string().nullable().notRequired(),
  description: yup.string(),
  options: yup.array().when('field_type', {
    is: (val: string) => {
      if (['radio', 'checkbox'].includes(val)) {
        return true
      }
      return false
    },
    then: yup
      .array()
      .of(
        yup.object().shape({
          label: yup.string().required('Nome da opção é obrigatório.'),
          value: yup.string().required('Valor da opção é obrigatório.'),
          uuid: yup.string().required('Identificador da opção é obrigatório.')
        })
      )
      .min(1, 'Adicione pelo menos uma opção'),
    otherwise: yup.array()
  }),
  value: yup.string().when('field_type', {
    is: 'accept',
    then: yup.string().required('Valor padrão é obrigatório.'),
    otherwise: yup.string()
  }),
  display_mode: yup.string().default('list'),
  // SC-11348: configuração do campo de upload
  accepted_types: yup
    .array()
    .of(yup.string().required())
    .when('field_type', {
      is: 'upload',
      then: yup
        .array()
        .of(yup.string().required())
        .min(1, 'Selecione pelo menos um tipo de arquivo'),
      otherwise: yup.array().of(yup.string().required())
    }),
  multiple: yup.boolean().default(false),
  max_files: yup
    .number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? null : value
    )
    .when(['field_type', 'multiple'], {
      is: (fieldType: string, multiple: boolean) =>
        fieldType === 'upload' && !!multiple,
      then: yup
        .number()
        .nullable()
        .typeError('Informe a quantidade máxima de arquivos')
        .required('Informe a quantidade máxima de arquivos')
        .integer('A quantidade máxima de arquivos deve ser um número inteiro')
        .min(
          UPLOAD_MIN_MULTIPLE_FILES,
          `A quantidade máxima de arquivos deve ser entre ${UPLOAD_MIN_MULTIPLE_FILES} e ${UPLOAD_MAX_FILES_LIMIT}`
        )
        .max(
          UPLOAD_MAX_FILES_LIMIT,
          `A quantidade máxima de arquivos deve ser entre ${UPLOAD_MIN_MULTIPLE_FILES} e ${UPLOAD_MAX_FILES_LIMIT}`
        ),
      otherwise: yup.number().nullable()
    })
})

export type ExtraFieldsSchemaType = yup.InferType<typeof extraFieldsSchema>
